<script>
import { onMount } from "svelte";
import LoggedIn from "../Components/Auth/LoggedIn.svelte";
import { options } from "../config";
import { loading } from "../loader";
import {  setRedirect } from "../Services/firebase";
import { GetContact, PostContact } from "../Services/form0";
import { user } from "../store";


    onMount(()=>{
            loading.set(true);
            setRedirect("/covid/member")
            GetContact(options.profile,"data_/understand.json",$user.idToken,(result)=>{
                PostContact({form:"covid/member",profile:options.profile,data:{}},$user.idToken,result=>{},error=>{})
                loading.set(false);
            },error=>{

            })
            
        
    })

</script>

<LoggedIn/>